import { Icon, Item, Label, Line } from './Styles';

const FormSteps = ({ steps, currentStep }) =>
  steps.map((stepName, index) => {
    const fixedIndex = index + 1;
    const isActive = fixedIndex === currentStep;
    const isCompleted = fixedIndex < currentStep;
    const isActiveOrCompleted = isActive || isCompleted;
    return (
      <Item key={index}>
        <Icon $isActive={isActive} $isCompleted={isCompleted}>
          {index + 1}
        </Icon>
        {index > 0 && <Line $isActiveOrCompleted={isActiveOrCompleted} />}
        <Label $isActiveOrCompleted={isActiveOrCompleted}>{stepName}</Label>
      </Item>
    );
  });
export default FormSteps;
